import { Component,OnInit } from '@angular/core';
import {MortiService} from '../services/morti.service';
import {Morto} from '../beans/morto';

@Component({
  selector: 'catalogo-morti-component',
  templateUrl: './catalogo-morti.component.html',
  styleUrls: ['./catalogo-morti.component.css']
})
export class CatalogoMortiComponent implements OnInit {
  
  morti:Morto[];

  constructor (private mortiService:MortiService){}

  ngOnInit():void{
  	this.mortiService.getMorti().then(morti=>this.morti=morti);
  }
}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/catalogo/catalogo-morti.component.ts